import useTranslation from 'next-translate/useTranslation';

import {Tabs} from '@/components/ui/Tabs';
import CompletedOrdersPanel from './CompletedOrdersPanel';
import ScheduledOrdersPanel from './ScheduledOrdersPanel';

const ORDERS_DROPDOWN_MODES = ['scheduled', 'completed'] as const;

type OrdersDropdownMode = (typeof ORDERS_DROPDOWN_MODES)[number];

// One component per mode, each in its own file, so the Scheduled and Completed data work can land
// in parallel without editing this file.
const MODE_PANELS: Record<OrdersDropdownMode, React.FC> = {
  scheduled: ScheduledOrdersPanel,
  completed: CompletedOrdersPanel,
};

/**
 * Phase 2b orders dropdown; defaults to "Scheduled"
 */
const OrdersDropdown: React.FC = () => {
  const {t} = useTranslation('app-bar');

  return (
    <div className="flex flex-col gap-4" data-testid="orders-dropdown">
      <Tabs defaultValue="scheduled">
        <Tabs.List aria-label={t('orders.dropdown.modes.label')} variant="segmented">
          {ORDERS_DROPDOWN_MODES.map(mode => (
            <Tabs.Trigger key={mode} value={mode}>
              {t(`orders.dropdown.modes.${mode}`)}
            </Tabs.Trigger>
          ))}
        </Tabs.List>

        {ORDERS_DROPDOWN_MODES.map(mode => {
          const Panel = MODE_PANELS[mode];

          return (
            <Tabs.Content
              className="min-h-40"
              data-testid={`orders-dropdown-${mode}-panel`}
              key={mode}
              value={mode}
            >
              <Panel />
            </Tabs.Content>
          );
        })}
      </Tabs>
    </div>
  );
};

export default OrdersDropdown;
